import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_LANG_KEY = 'CLEAR2WORK_LANG';

const getInitialLang = () => {
      const saved = localStorage.getItem(STORAGE_LANG_KEY);
      if (saved === 'tr' || saved === 'en') return saved;
      return 'tr'; // Default to Turkish
};

const resources = {
      tr: {
            translation: {
                  // ========== GENEL ==========
                  appName: 'Clear2Work',
                  appSubtitle: 'Güvenli Giriş ve Evrak Doğrulama Sistemi',
                  login: 'Giriş Yap',
                  email: 'E-posta',
                  password: 'Şifre',
                  logout: 'Çıkış',
                  dashboard: 'Kontrol Paneli',
                  personnel: 'Personel',
                  entryCheck: 'Giriş Kontrolü',
                  entryLogs: 'Kayıt Geçmişi',
                  settings: 'Ayarlar',
                  users: 'Kullanıcılar',
                  mainMenu: 'Ana Menü',
                  preferences: 'Tercihler',
                  account: 'Hesap Bilgileri',
                  makeEntry: 'Giriş Yap',
                  makeExit: 'Çıkış Yap',
                  gateSelection: 'Saha Seçimi',
                  darkTheme: 'Koyu Tema',
                  lightTheme: 'Açık Tema',
                  onlySelected: 'Sadece seçilenler',
                  noRecordsFound: 'Kayıt bulunamadı',
                  noResults: 'Sonuç bulunamadı',
                  enterAtLeastOne: 'Lütfen en az bir alan doldurun',
                  alerts: 'uyarı',
                  selected: 'seçili',
                  entryControlSystem: 'Giriş Kontrol Sistemi',
                  authorizedAccess: 'Yetkili erişim',
                  liveSystem: 'Aktif sistem',
                  entryControlCenter: 'Giriş Kontrol Merkezi',
                  lastEntryDate: 'Son giriş',
                  lastExitDate: 'Son çıkış',
                  todayInsideDuration: 'Bugünkü toplam süre',
                  lastUsedGate: 'Son kullanılan saha',
                  entryRestricted: 'Giriş yetkisi kısıtlı',
                  assignmentNotStarted: 'Görevlendirme tarihi henüz başlamadı',
                  assignmentExpiredReason: 'Görevlendirme süresi dolmuş',
                  adminBlockedReason: 'Yönetici tarafından engellenmiş',
                  mandatoryDocumentMissing: 'Zorunlu belge eksik',
                  expiredDocumentReason: 'Belge süresi dolmuş',
                  blockPersonnelEntry: 'Personelin girişini yönetici olarak engelle',
                  blockReasonPlaceholder: 'Engelleme nedenini yazın',

                  search: 'Ara',
                  searchPlaceholder: 'İsim, TC, Şirket veya Plaka ile ara...',
                  add: 'Ekle',
                  addPersonnel: 'Personel Ekle',
                  fullName: 'Ad Soyad',
                  tcNumber: 'TC Kimlik No',
                  company: 'Şirket',
                  phone: 'Telefon',
                  licensePlate: 'Plaka',
                  photoUrl: 'Fotoğraf URL',
                  assignmentStart: 'Görev Başlangıç',
                  assignmentEnd: 'Görev Bitiş',
                  save: 'Kaydet',
                  autoExitBadge: 'Otomatik',
                  autoCloseTitle: 'Unutulan Çıkışları Otomatik Kapat',
                  autoCloseDesc: '{{hours}} saatten uzun süredir içeride görünen personele otomatik ÇIKIŞ yazılır. Çıkış saati, giriş saati + {{hours}} saat olarak kaydedilir.',
                  autoCloseEnabled: 'Otomatik kapatma açık',
                  autoCloseHours: 'Süre (saat)',
                  autoClosePreview: 'Kimler kapanacak? (Önizleme)',
                  autoCloseNone: 'Şu an kapatılacak kimse yok.',
                  autoCloseWillClose: '{{count}} kişi için çıkış yazılacak:',
                  autoCloseInSince: 'giriş:',
                  autoCloseRunNow: 'Bunları şimdi kapat',
                  autoCloseSaved: 'Otomatik çıkış ayarı kaydedildi',
                  autoCloseDone: '{{count}} kişi için otomatik çıkış yazıldı',
                  cancel: 'İptal',
                  edit: 'Düzenle',
                  delete: 'Sil',

                  // ========== BELGELER ==========
                  documents: 'Evraklar',
                  documentTypes: 'Evrak Tipleri',
                  addDocumentType: 'Evrak Tipi Ekle',
                  addDocument: 'Evrak Ekle',
                  documentType: 'Evrak Tipi',
                  expiryDate: 'Son Geçerlilik Tarihi',
                  notes: 'Notlar',
                  mandatory: 'Zorunlu',
                  warningDays: 'Uyarı Günü',
                  status: 'Durum',
                  valid: 'Geçerli',
                  warning: 'Uyarı',
                  expired: 'Süresi Dolmuş',

                  // ========== SİSTEM ==========
                  newReport: 'Yeni Rapor',
                  systemStatus: 'Sistem Durumu',
                  allSystemsOperational: 'Tüm sistemler çalışıyor',
                  database: 'Veritabanı',
                  apiLatency: 'API Gecikmesi',
                  online: 'ÇEVRİMİÇİ',

                  // ========== UYARILAR ==========
                  actionRequired: 'Aksiyon Gerekiyor',
                  expiringDocumentsSubtitle: 'Süresi dolan evraklar',
                  recentActivity: 'Son Aktiviteler',
                  last24Hours: 'Son 24 Saat',
                  searchInsights: 'İçerik ara...',

                  // ========== AYARLAR ==========
                  appearance: 'Görünüm',
                  language: 'Dil',

                  // ========== GİRİŞ/ÇIKIŞ ==========
                  entries: 'Girişler',
                  exits: 'Çıkışlar',
                  hourlyActivityBreakdown: 'Saatlik aktivite dağılımı',
                  review: 'İncele',
                  mainGate: 'Liman Sahası',
                  entryBadge: 'GİRİŞ',
                  exitBadge: 'ÇIKIŞ',

                  // ========== DASHBOARD ==========
                  activeValidDocs: 'Aktif & Geçerli Evrak',
                  expiredOrMissing: 'Süresi Dolmuş / Eksik',
                  expiringInDays: '{{days}} gün içinde doluyor',
                  recordArchive: 'Kayıt Arşivi',
                  timeInside: 'İçeride Geçen',
                  totalTime: 'Toplam Süre',

                  // ========== ONAY/RED ==========
                  approve: 'Onayla',
                  reject: 'Reddet',
                  approveEntry: 'Girişi Onayla',
                  rejectEntry: 'Girişi Reddet',
                  selectReason: 'Red Sebebi Seçin',
                  missingDocuments: 'Eksik Evrak',
                  expiredDocuments: 'Süresi Dolmuş Evrak',
                  unauthorized: 'Yetkisiz Kişi',
                  other: 'Diğer',
                  decision: 'Karar',
                  approved: 'Onaylandı',
                  rejected: 'Reddedildi',
                  reason: 'Sebep',
                  checkedBy: 'Kontrol Eden',
                  timestamp: 'Zaman',

                  // ========== İSTATİSTİKLER ==========
                  totalPersonnel: 'Toplam Personel',
                  entriesToday: 'Bugünkü Girişler',
                  approvedToday: 'Bugün Onaylanan',
                  rejectedToday: 'Bugün Reddedilen',
                  recentEntries: 'Son Girişler',
                  daysUntilExpiry: 'Süre Dolumuna Kalan Gün',

                  // ========== MESAJLAR ==========
                  entryApproved: 'Giriş onaylandı',
                  entryRejected: 'Giriş reddedildi',
                  pleaseSelectReason: 'Lütfen red sebebini seçin',
                  noResultsFound: 'Kişi bulunamadı',
                  searchToStart: 'Aramaya başlamak için yukarıdaki arama çubuğunu kullanın',
                  loading: 'Yükleniyor...',

                  // ========== FORM ALANLARI ==========
                  nameTr: 'Türkçe İsim',
                  nameEn: 'İngilizce İsim',
                  actions: 'İşlemler',
                  view: 'Görüntüle',
                  back: 'Geri',

                  // ========== KAPLAR (GATES) ==========
                  ADMIN_BUILDING: 'İdari Bina',
                  PORT_FACILITY: 'Liman Tesisi',
                  OFFDOCK1_SAYINLAR: 'Offdock1 Sahası (Sayınlar)',
                  OFFDOCK2_KOMURLER: 'Offdock2 Sahası (Kömürler)',

                  // ========== LANDING & LOGIN ==========
                  heroTitle1: 'Girişleri Denetleyin,',
                  heroTitle2: 'Sahanızı Güvenceye Alın',
                  heroSubtitle: 'Dijital giriş kayıtları, anlık takip ve akıllı raporlama ile saha güvenliğinizi profesyonel bir platformda yönetin.',
                  startNow: 'Hemen Başla',
                  safeInfra: 'Güvenli Altyapı',
                  freeUsage: '%100 Ücretsiz',
                  nonStopTrack: 'Kesintisiz Takip',
                  highSecurity: 'Veri Gizliliği',
                  highSecurityDesc: 'Bilgileriniz güvenle saklanır.',
                  realTimeTrack: 'Gerçek Zamanlı Takip',
                  realTimeTrackDesc: 'Anlık panel üzerinden izleyin.',
                  smartReporting: 'Akıllı Raporlama',
                  smartReportingDesc: 'Özel raporlar oluşturun.',
                  googleLogin: 'Google ile Devam Et',
                  appleLogin: 'Apple ile Devam Et',
                  or: 'veya',
                  forgotPasswordBtn: 'Şifremi Unuttum',
                  noAccount: 'Hesabınız yok mu?',
                  register: 'Kayıt Ol',
                  resetPassword: 'Şifre Sıfırlama',
                  resetPasswordDesc: 'E-posta adresinizi girerek şifre sıfırlama bağlantısı isteyin.',
                  send: 'Gönder',
                  industrialSystem: 'Dijital Erişim ve Güvenlik Kontrol Sistemi',


                  // ✅ Login
                  welcomeBack: 'Hoş Geldiniz',
                  enterCredentials: 'Devam etmek için bilgilerinizi girin',
                  allRightsReserved: 'Tüm hakları saklıdır.',
                  login: 'Giriş Yap',
                  loginLoading: 'Giriş yapılıyor...',
                  username: 'Kullanıcı Adı',
                  password: 'Şifre',
                  usernamePlaceholder: 'Kullanıcı adınızı girin',
                  passwordPlaceholder: 'Şifrenizi girin',
                  forgotPassword: 'Şifremi Unuttum',
                  forgotPasswordTitle: 'Şifre Sıfırlama',
                  forgotPasswordDesc: 'Şifrenizi sıfırlamak için e-posta adresinizi girin',
                  sendResetLink: 'Sıfırlama Bağlantısı Gönder',
                  sending: 'Gönderiliyor...',
                  fillAllFields: 'Lütfen tüm alanları doldurun',
                  missingInfo: 'Eksik Bilgi',
                  loginSuccess: 'Giriş Başarılı',
                  redirecting: 'Yönlendiriliyorsunuz...',
                  loginDenied: 'Giriş Reddedildi',
                  invalidCredentials: 'Kullanıcı adı veya şifre hatalı!',
                  loginFailed: 'Giriş yapılamadı. Tekrar deneyin.',
                  emailSent: 'E-posta Gönderildi',
                  resetLinkSent: 'Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.',
                  operationFailed: 'İşlem başarısız oldu.',
                  forgotPasswordHint: 'Şifrenizi mi unuttunuz? Destek ekibiyle iletişime geçin.',
                  daysUntilExpiry: '{{days}} gün kaldı',
                  role: 'Rol',
                  admin: 'Yönetici',
                  security: 'Güvenlik',
                  supervisor: 'Denetçi',
                  // username: 'Kullanıcı Adı', // Duplicate, removed
                  // loginLoading: 'Giriş yapılıyor...', // Duplicate, removed
                  // forgotPassword: 'Şifrenizi mi unuttunuz?', // Duplicate, removed
                  // forgotPasswordTitle: 'Şifre Sıfırlama', // Duplicate, removed
                  // forgotPasswordDesc: 'Şifrenizi sıfırlama talimatları için lütfen e-postanızı girin.', // Duplicate, removed
                  // sendResetLink: 'Sıfırlama Bağlantısı Gönder', // Duplicate, removed

                  // ========== PERSONEL BİLGİLERİ ==========
                  personnelInfo: 'Personel Bilgileri',
                  optional: 'Opsiyonel',
                  enterExpiryDates: 'Son geçerlilik tarihlerini girin (isteğe bağlı)',
                  noDocumentTypes: "Evrak tipi bulunamadı. Lütfen önce Ayarlar'dan evrak tipi ekleyin.",
                  goToSettings: 'Ayarlara Git',
                  areYouSure: 'Emin misiniz?',
                  documentTypeAdded: 'Belge tipi başarıyla eklendi',
                  manageDocumentTypes: 'Belge tiplerini buradan yönetebilirsiniz',
                  warningDaysHelp: 'Süre bitimine kaç gün kala uyarı verileceğini belirtin',
                  days: 'gün',

                  // ========== DURUM MESAJLARI ==========
                  assignmentExpired: 'Görev süresi dolmuş - GİRİŞ YASAK',
                  documentsExpired: 'Evrakları eksik/süresi geçmiş - GİRİŞ YASAK',
                  documentsWarning: 'Evraklar yakında süre dolacak - UYARI',
                  allDocumentsValid: 'Tüm evraklar geçerli - GİRİŞ İZNİ VAR',
                  searchPersonnelToCheck: 'Giriş kontrolü için personel arayın',
                  selectPersonnelToViewStatus: 'Durum görmek için personel seçin',
                  noDocuments: 'Evrak bulunamadı',

                  // ========== UYARILAR ==========
                  expiringDocuments: 'Süresi Yaklaşan Evraklar',
                  noAlerts: 'Uyarı bulunmuyor',
                  daysLeft: 'gün kaldı',
                  alreadyExpired: 'SÜRESİ DOLMUŞ',
                  viewAll: 'Tümünü Gör',
                  alertsIn30Days: '14 gün içinde süresi dolacak evraklar',
                  urgentAlerts: 'Acil Uyarılar',

                  // ========== SAYFALAMA ==========
                  page: 'Sayfa',
                  previous: 'Önceki',
                  next: 'Sonraki',
                  of: '/',

                  // ========== KULLANICI YÖNETİMİ ==========
                  userManagement: 'Kullanıcı Yönetimi',
                  addUser: 'Kullanıcı Ekle',
                  editUser: 'Kullanıcı Düzenle',
                  userCreated: 'Kullanıcı oluşturuldu',
                  userUpdated: 'Kullanıcı güncellendi',
                  userDeleted: 'Kullanıcı silindi',

                  // ========== YETKİLENDİRME ==========
                  canEnter: 'Giriş Yetkisi Onaylı',
                  cannotEnter: 'Giriş Yetkisi Kısıtlı',
                  allDocsValid: 'Uygunluk doğrulandı',
                  docProblem: 'Uygunluk sağlanmadı',

                  // ========== KAYITLAR ==========
                  accessLogsTitle: 'Giriş ve Çıkış Kayıtları',
                  autoRefresh: 'Otomatik yenileme',
                  entryLogsTitle: 'Giriş ve Çıkış Kayıtları',
                  last24HoursHint: 'Son kayıtlar listelenir',
                  openSearch: 'Kayıt Ara',
                  all: 'Tümü',
                  in: 'Giriş',
                  out: 'Çıkış',
                  day: 'Gün',
                  refresh: 'Yenile',
                  refreshLatest: 'Son Kayıtları Yenile',
                  noRecordsYet: 'Henüz kayıt yok.',
                  entered: 'GİRİŞ',
                  exited: 'ÇIKIŞ',
                  entryTime: 'Giriş',
                  exitTime: 'Çıkış',
                  securityOfficer: 'Güvenlik Personeli',
                  openPersonnel: 'Personeli aç',
                  totalRecords: 'Toplam {{count}} kayıt',
                  records: 'Kayıt',

                  // ========== ARAMA ==========
                  expiringSoon: 'Yaklaşan',
                  alreadyExpiredCount: 'Süresi Dolmuş',
                  searchByNameCompanyPhone: 'İsim, şirket veya telefon ile ara...',
                  showingExpiringFirst: 'Önce süresi yaklaşanlar, sonra dolmuşlar gösteriliyor',
                  noSearchResults: 'Arama sonucu bulunamadı',
                  timeFilter: 'Süre',

                  // ========== KULLANICILAR ==========
                  newUser: 'Yeni Kullanıcı',
                  createdAt: 'Oluşturulma',
                  noUsersYet: 'Henüz kullanıcı bulunmuyor',
                  update: 'Güncelle',
                  passwordHint: 'Boş bırakılırsa değişmez',

                  // ========== TOPLU İŞLEMLER ==========
                  downloadTemplate: 'Şablon İndir',
                  bulkImportExcel: 'Excel İle Toplu Ekle',
                  manualAdd: 'Manuel Ekle',
                  excelFormat: 'Excel Formatı',
                  requiredColumns: 'Zorunlu sütunlar',
                  optionalColumns: 'Opsiyonel',
                  dateFormat: 'Tarih formatı',
                  importantNote: 'Önemli',
                  emptyFieldsIgnored: 'Boş bıraktığınız alanlar eklenmeyecek',

                  // ========== KAYIT FİLTRELERİ ==========
                  entryLogsAll: 'Tümü',
                  entryLogsIn: 'Giriş',
                  entryLogsOut: 'Çıkış',
                  entryLogsDay: 'Gün',
                  entryLogsRefresh: 'Yenile',
                  entryLogsCalculating: 'Hesaplanıyor...',
                  entryLogsOnlyOutHint: 'Gün toplamı yalnızca ÇIKIŞ satırında görünür.',
                  entryLogsSearchBtn: 'Kayıt Arama',
                  entryLogsNotFound: 'Kayıt bulunamadı',
                  entryLogsTotal: 'Toplam {{count}} kayıt',
                  totalRecordsShort: 'Toplam kayıt',
                  noRecords: 'Kayıt bulunamadı',
                  date: 'Tarih',
                  action: 'İşlem',
                  note: 'Not',
                  officer: 'Görevli',
                  duration: 'Toplam Süre',
                  hoursUnit: 'sa',
                  minutesUnit: 'dk',
                  secondsUnit: 'sn',

                  // ✅ Security Check
                  insideTitle: 'İçeride',
                  insideSubtitle: 'Anlık içeride bulunan personel ve süreleri',
                  refresh: 'Yenile',
                  loading: 'Yükleniyor...',
                  noOneInside: 'İçeride kimse yok.',
                  totalDuration: 'Toplam Süre',
                  security: 'GÜVENLİK',
                  gate: 'Saha',
                  allowEntry: 'Giriş Ver',
                  allowExit: 'Çıkış Ver',
                  personnelInside: 'Personel içeride',
                  personnelNotInside: 'Personel içeride değil',
                  noEntryPermission: 'Giriş izni yok',
                  assignmentDuration: 'GÖREV SÜRESI',
                  selectPersonnelPlaceholder: 'Durum görmek için personel seçin',
                  searchFailed: 'Arama başarısız',
                  failedToLoadDetails: 'Detaylar yüklenemedi',
                  personNotFound: 'Personel bulunamadı',
                  entrySaved: 'Giriş kaydedildi',
                  exitSaved: 'Çıkış kaydedildi',
                  operationFailed: 'İşlem başarısız',

                  personSearch: 'Kişi Arama',
                  name: 'Ad',
                  surname: 'Soyad',
                  searchAction: 'ARA',
                  searchFormWarning: 'Arama yapmak için lütfen yukarıdaki alanlardan (<1>Ad, Soyad veya Kimlik No</1>) en az birini doldurunuz.',
                  daysShort: 'g',
                  hoursUnit: 'sa',
                  minutesUnit: 'dk',
                  secondsUnit: 'sn',
                  entryTime: 'Giriş Saati',
                  insideTime: 'İçeride Geçen Süre',

                  // ========== KAYIT ARAMA ==========
                  entryLogsSearchTitle: 'Kayıt Arama',
                  entryLogsSearchSubtitle: 'Detaylı arama yapın',
                  entryLogsSearchPlaceholder: 'İsim / şirket / not / görevli ara...',
                  entryLogsSearchBtnShort: 'Ara',
                  entryLogsSearchSearching: 'Aranıyor...',
                  entryLogsSearchNoResult: 'Sonuç bulunamadı',
                  entryLogsSearchDayFilter: 'Gün filtresi',
                  entryLogsSearchHintOn: 'Gün filtresi açık: sadece seçili gün taranır.',
                  entryLogsSearchHintOff: 'Gün filtresi kapalı: geriye dönük tüm kayıtlar taranır.',
                  entryLogsSearchScanned: 'Taranan sayfa: {{scanned}} / {{total}} — Bulunan: {{found}}',
                  entryLogsSearchTotalDuration: 'Toplam Süre',
                  entryLogsSearchSecurity: 'Güvenlik',
                  entryLogsSearchNoteLabel: 'Not',
                  entryLogsSearchDateLabel: 'Tarih',
                  entryLogsSearchEntry: 'Giriş',
                  entryLogsSearchExit: 'Çıkış',

                  // ========== YENİ EKLENENLER (EntryLogsSearch) ==========
                  searchRecords: 'Kayıt Arama',
                  searchDetailed: 'Detaylı arama yapın',
                  searchAllFields: 'İsim / şirket / not / görevli / saha ara...',
                  allRecords: 'Tümü',
                  dayFilterEnabled: 'Gün filtresi açık: sadece seçili gün taranır.',
                  dayFilterDisabled: 'Gün filtresi kapalı: geriye dönük tüm kayıtlar taranır.',
                  scannedInfo: 'Taranan sayfa: {{scanned}} / {{total}} — Bulunan: {{found}}',
                  totalDurationLabel: 'Toplam Süre:',
                  site: 'Saha',

                  // ========== KISA KAYIT ARAMASI ==========
                  logsSearchTitle: 'Kayıt Arama',
                  searchHint: 'İsim / şirket / not / görevli ara...',
                  dayFilter: 'Gün filtresi',
                  searching: 'Aranıyor...',
                  scannedPages: 'Taranan sayfa',
                  found: 'Bulunan',
                  entry: 'Giriş',
                  exit: 'Çıkış',

                  // ========== DASHBOARD EKSTRALARİ ==========
                  entryExitLogsTitle: 'Giriş ve Çıkış Kayıtları',
                  showingLastHours: 'Son {{hours}} saat gösteriliyor',
                  entryLabel: 'Giriş:',
                  exitLabel: 'Çıkış:',
                  durationLabel: 'Toplam:',
                  insideLabel: 'İçeride:',
                  guardLabel: 'Güvenlik:',
                  enteredFacility: '{{name}} tesise girdi',
                  exitedFacility: '{{name}} tesisten çıktı',
                  openLogsArchive: 'Kayıt Arşivini Aç',
                  refreshBtn: 'Yenile',
                  loadingLogs: 'Kayıtlar yükleniyor...',
                  noActivityLastHours: 'Son {{hours}} saatte hareket kaydı yok.',
                  noRecentActivity: 'Son 24 saatte hareket kaydı bulunamadı',
                  logsLoadFailed: 'Kayıtlar yüklenemedi',
                  durationHMS: '{{h}} sa {{m}} dk {{s}} sn',
                  durationMS: '{{m}} dk {{s}} sn',
                  urgentExpiresInDays: '{{days}} gün içinde süresi dolacak',
                  mostUrgent: 'En acil',
                  noUrgentAlerts: 'Acil uyarı bulunmuyor',

                  // ========== KAYIT LİSTESİ ==========
                  entryExitRecords: 'Giriş ve Çıkış Kayıtları',
                  showingLast24Hours: 'Son 24 saat gösteriliyor',
                  searchRecord: 'Kayıt Ara',
                  insideTime: 'İçeride',
                  lessThanOneMinute: '<1 dk',
                  minutesShort: '{{m}} dk',
                  hoursMinutesShort: '{{h}} sa {{m}} dk',
                  searchDayFilterOn: 'Gün filtresi açık: sadece seçili gün taranır.',
                  searchDayFilterOff: 'Gün filtresi kapalı: geriye dönük tüm kayıtlar taranır.',
                  // logsSearchTitle: 'Kayıt Arama', // Duplicate, removed
                  searchDetailedHint: 'Detaylı arama yapın',
                  searchButton: 'Ara',
                  // dayFilter: 'Gün filtresi', // Duplicate, removed
                  calculating: 'hesaplanıyor...',
                  ready: 'hazır',
                  // searching: 'Aranıyor...', // Duplicate, removed
                  noteLabel: 'Not',
                  // guardLabel: 'Güvenlik:', // Duplicate, removed

                  // ========== PERSONEL YÖNETİMİ ==========
                  personnelLoadFailed: 'Personel yüklenemedi',
                  downloadPersonnelBackup: 'Personel Excel Yedeği',
                  preparingExcel: 'Excel hazırlanıyor...',
                  personnelBackupDownloaded: 'Personel Excel yedeği indirildi',
                  personnelBackupFailed: 'Personel Excel yedeği oluşturulamadı',
                  personnelDeleted: 'Personel silindi',
                  personnelDeleteFailed: 'Personel silinemedi',
                  bulkDeleteSuccess: '✅ {{count}} kayıt silindi',
                  bulkDeleteFailed: 'Toplu silme başarısız',
                  importSuccess: '✅ {{imported}} personel eklendi, {{skipped}} atlandı',
                  importWarning: '⚠️ {{count}} hata oluştu. Console\'a bakın.',
                  importFailed: 'Excel import başarısız',
                  templateDownloaded: 'Şablon indirildi',
                  templateDownloadFailed: 'Şablon indirilemedi',
                  deletePageItems: 'Sayfadakileri Sil ({{count}})',
                  deleteSelected: 'Seçilenleri Sil ({{count}})',
                  uploading: 'Yükleniyor...',
                  clearSelection: 'Seçimi Temizle',
                  clearFilters: 'Temizle',
                  allPersonnel: 'Hepsi',
                  canEnterFilter: 'Girebilecek',
                  cannotEnterFilter: 'Giremeyecek',
                  searchNameTcCompany: 'Ad, TC, Şirket...',
                  allCompanies: 'Tüm Şirketler',
                  // onlySelected: 'Sadece seçilenler', // Duplicate, removed
                  totalLabel: 'Toplam',
                  visibleLabel: 'Görünen',
                  totalPersonnelCount: 'Toplam {{count}} personel',
                  pageOf: 'Sayfa {{current}} / {{total}}',
                  deleteSelectedTitle: 'Seçilenleri Sil',
                  deletePageItemsTitle: 'Sayfadaki Kayıtları Sil',
                  deleteConfirmMessage: 'Bu işlem geri alınamaz. Devam etmek için',
                  deleteKeyword: 'SİL',
                  typeToConfirm: 'yazın.',
                  cancelAction: 'Vazgeç',
                  deleteButton: 'Sil',

                  // ========== AYARLAR ==========
                  settingsTitle: 'Ayarlar',
                  documentTypesTitle: 'Belge Tipleri',
                  documentTypesSubtitle: 'Belge tiplerini yönetin',
                  addDocumentTypeTitle: 'Belge Tipi Ekle',
                  nameTrLabel: 'Türkçe Adı',
                  nameEnLabel: 'İngilizce Adı',
                  warningDaysLabel: 'Uyarı Günü',
                  warningDaysHint: 'Kaç gün önceden uyarı verilsin',
                  mandatoryDocument: 'Zorunlu Belge',
                  noDocumentTypesYet: 'Henüz belge tipi yok',
                  documentTypeDeleteConfirm: 'Belge tipi silinsin mi?',
                  documentTypeDeleted: 'Belge tipi silindi',
                  documentTypeDeleteFailed: 'Belge tipi silinemedi',
                  documentTypeCreateFailed: 'Belge tipi eklenemedi',

                  // ========== SMS TEST ==========
                  smsTestTitle: 'SMS Test',
                  phoneLabel: 'Telefon',
                  messageLabel: 'Mesaj',
                  countryCodeHint: 'Ülke kodu ile birlikte (örn: +90)',
                  // sending: 'Gönderiliyor...', // Duplicate, removed
                  sendTestSms: 'Test SMS Gönder',
                  smsSent: 'SMS başarıyla gönderildi',
                  smsSendFailed: 'SMS gönderilemedi',
                  smsNoteTitle: 'Not',
                  smsBackendNote: 'SMS servisi için backend .env dosyasında Twilio bilgileri yapılandırılmalıdır. Yönetici ile iletişime geçin: TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN, TWILIO_PHONE_NUMBER',

                  // ========== PERSONEL DETAY ==========
                  personnelNotFound: 'Personel bulunamadı',
                  failedToLoadData: 'Veriler yüklenemedi',
                  personnelUpdated: 'Personel güncellendi',
                  updateFailed: 'Güncelleme başarısız',
                  documentAdded: 'Evrak eklendi',
                  documentAddFailed: 'Evrak eklenemedi',
                  documentDeleted: 'Evrak silindi',
                  documentDeleteFailed: 'Evrak silinemedi',
                  personnelAddSuccess: 'Personel başarıyla eklendi',
                  personnelAddFailed: 'Personel eklenemedi',
                  docTypesLoadFailed: 'Evrak tipleri yüklenemedi',
                  confirmDelete: 'Emin misiniz?',
                  newDocumentAdd: 'Yeni Evrak Ekle',
                  select: 'Seçin',
                  expiresOn: 'Son Geçerlilik',
                  // expiresOn: 'Son Geçerlilik', // Duplicate, removed
                  expired: 'Süresi geçmiş',

                  // ========== PERSONEL AKSİYON GRID ==========
                  singleEntryDesc: 'Tekil personel girişi',
                  selectAndUploadFile: 'Dosya Seç & Yükle',
                  deleteSelectedCount: 'Seçilenleri Sil ({{count}})',
                  deletePageAll: 'Sayfadaki Tümünü Sil ({{count}})',
                  bulkActionHint: 'Toplu işlemler için seçim yapın',
                  bulkActions: 'Toplu İşlemler',

                  // ========== RAPOR ==========
                  downloadReport: 'Rapor İndir',
                  downloadMonthlyReport: 'Aylık Rapor İndir',
                  year: 'Yıl',
                  month: 'Ay',
                  downloadExcel: 'Excel İndir',
                  downloadFailed: 'İndirme başarısız oldu',

                  // ========== SECURITYCHECKiçin EKLENDİ ==========
                  inside: 'İçeride',
                  liveInsideList: 'Anlık içeride bulunan personel ve süreleri',
                  siteSelection: 'Saha Seçimi',
                  simulation: 'Simülasyon',
                  giveEntry: 'Giriş Ver',
                  giveExit: 'Çıkış Ver',
                  personnelInside: 'Personel içeride',
                  personnelNotInside: 'Personel içeride değil',
                  noEntryPermission: 'Giriş izni yok',
                  docsNotSuitable: 'Evrak/Görev uygun değil',
                  entrySaved: 'Giriş kaydedildi',
                  exitSaved: 'Çıkış kaydedildi',
                  operationFailed: 'İşlem başarısız',
                  noOneInside: 'İçeride kimse yok',
                  cannotExit: 'Çıkış verilemez',
                  failedToLoadDetails: 'Detaylar yüklenemedi',

                  // ========== ENTRYCHECK İÇİN ==========
                  manualEntry: 'Manuel Giriş',
                  manualEntryControls: 'Manuel Giriş Kontrolleri',

                  // ========== YAKINDA ==========
                  comingSoonTitle: 'Yakında',
                  comingSoonDesc: 'Bu özellik henüz aktif değil. Yakında kullanılabilir olacak.',
            },
      },

      en: {
            translation: {
                  // ========== GENERAL ==========
                  appName: 'Clear2Work',
                  appSubtitle: 'Document Check & Site Entry Approval',
                  login: 'Login',
                  email: 'Email',
                  password: 'Password',
                  logout: 'Logout',
                  dashboard: 'Dashboard',
                  personnel: 'Personnel',
                  entryCheck: 'Entry Check',
                  entryLogs: 'Record History',
                  settings: 'Settings',
                  users: 'Users',
                  mainMenu: 'Main Menu',
                  preferences: 'Preferences',
                  account: 'Account Info',
                  makeEntry: 'Make Entry',
                  makeExit: 'Make Exit',
                  gateSelection: 'Field Selection',
                  darkTheme: 'Dark Theme',
                  lightTheme: 'Light Theme',
                  onlySelected: 'Only selected',
                  noRecordsFound: 'No records found',
                  noResults: 'No results found',
                  enterAtLeastOne: 'Please fill in at least one field',
                  alerts: 'alerts',
                  selected: 'selected',
                  entryControlSystem: 'Entry Control System',
                  authorizedAccess: 'Authorized access',
                  liveSystem: 'Live system',
                  entryControlCenter: 'Entry Control Center',
                  lastEntryDate: 'Last entry',
                  lastExitDate: 'Last exit',
                  todayInsideDuration: 'Today total time',
                  lastUsedGate: 'Last used site',
                  entryRestricted: 'Entry permission restricted',
                  assignmentNotStarted: 'Assignment has not started yet',
                  assignmentExpiredReason: 'Assignment period has expired',
                  adminBlockedReason: 'Blocked by administrator',
                  mandatoryDocumentMissing: 'Mandatory document missing',
                  expiredDocumentReason: 'Document has expired',
                  blockPersonnelEntry: 'Block personnel entry as administrator',
                  blockReasonPlaceholder: 'Enter the blocking reason',

                  search: 'Search',
                  searchPlaceholder: 'Search by name, ID, company or license plate...',
                  add: 'Add',
                  addPersonnel: 'Add Personnel',
                  fullName: 'Full Name',
                  tcNumber: 'ID Number',
                  company: 'Company',
                  phone: 'Phone',
                  licensePlate: 'License Plate',
                  photoUrl: 'Photo URL',
                  assignmentStart: 'Assignment Start',
                  assignmentEnd: 'Assignment End',
                  save: 'Save',
                  autoExitBadge: 'Auto',
                  autoCloseTitle: 'Auto-close Forgotten Exits',
                  autoCloseDesc: 'Personnel shown inside for more than {{hours}} hours get an automatic EXIT. Exit time is recorded as entry time + {{hours}} hours.',
                  autoCloseEnabled: 'Auto-close enabled',
                  autoCloseHours: 'Limit (hours)',
                  autoClosePreview: 'Who would be closed? (Preview)',
                  autoCloseNone: 'Nobody to close right now.',
                  autoCloseWillClose: 'An exit will be recorded for {{count}} people:',
                  autoCloseInSince: 'entered:',
                  autoCloseRunNow: 'Close these now',
                  autoCloseSaved: 'Auto-close settings saved',
                  autoCloseDone: 'Automatic exit recorded for {{count}} people',
                  cancel: 'Cancel',
                  edit: 'Edit',
                  delete: 'Delete',

                  // ========== DOCUMENTS ==========
                  documents: 'Documents',
                  documentTypes: 'Document Types',
                  addDocumentType: 'Add Document Type',
                  addDocument: 'Add Document',
                  documentType: 'Document Type',
                  expiryDate: 'Expiry Date',
                  notes: 'Notes',
                  mandatory: 'Mandatory',
                  warningDays: 'Warning Days',
                  status: 'Status',
                  valid: 'Valid',
                  warning: 'Warning',
                  expired: 'Expired',

                  // ========== SYSTEM ==========
                  newReport: 'New Report',
                  systemStatus: 'System Status',
                  allSystemsOperational: 'All systems operational',
                  database: 'Database',
                  apiLatency: 'API Latency',
                  online: 'ONLINE',

                  // ========== ALERTS ==========
                  actionRequired: 'Action Required',
                  expiringDocumentsSubtitle: 'Expiring documents',
                  recentActivity: 'Recent Activity',
                  last24Hours: 'Last 24 Hours',
                  searchInsights: 'Search insights...',

                  // ========== SETTINGS ==========
                  appearance: 'Appearance',
                  language: 'Language',

                  // ========== ENTRY/EXIT ==========
                  entries: 'Entries',
                  exits: 'Exits',
                  hourlyActivityBreakdown: 'Hourly activity breakdown',
                  review: 'Review',
                  mainGate: 'Port Facility',
                  entryBadge: 'ENTRY',
                  exitBadge: 'EXIT',

                  // ========== DASHBOARD ==========
                  activeValidDocs: 'Active & Valid Docs',
                  expiredOrMissing: 'Expired or Missing',
                  expiringInDays: 'Expiring in {{days}} days',
                  recordArchive: 'Record Archive',
                  timeInside: 'Time Inside',
                  totalTime: 'Total Time',

                  // ========== APPROVE/REJECT ==========
                  approve: 'Approve',
                  reject: 'Reject',
                  approveEntry: 'Approve Entry',
                  rejectEntry: 'Reject Entry',
                  selectReason: 'Select Rejection Reason',
                  missingDocuments: 'Missing Documents',
                  expiredDocuments: 'Expired Documents',
                  unauthorized: 'Unauthorized Person',
                  other: 'Other',
                  decision: 'Decision',
                  approved: 'Approved',
                  rejected: 'Rejected',
                  reason: 'Reason',
                  checkedBy: 'Checked By',
                  timestamp: 'Timestamp',

                  // ========== STATISTICS ==========
                  totalPersonnel: 'Total Personnel',
                  entriesToday: 'Entries Today',
                  approvedToday: 'Approved Today',
                  rejectedToday: 'Rejected Today',
                  recentEntries: 'Recent Entries',
                  daysUntilExpiry: 'Days Until Expiry',

                  // ========== MESSAGES ==========
                  entryApproved: 'Entry approved',
                  entryRejected: 'Entry rejected',
                  pleaseSelectReason: 'Please select rejection reason',
                  noResultsFound: 'No results found',
                  searchToStart: 'Use the search bar above to start',
                  loading: 'Loading...',

                  // ========== FORM FIELDS ==========
                  nameTr: 'Turkish Name',
                  nameEn: 'English Name',
                  actions: 'Actions',
                  view: 'View',
                  back: 'Back',

                  // ========== GATES ==========
                  ADMIN_BUILDING: 'Admin Building',
                  PORT_FACILITY: 'Port Facility',
                  OFFDOCK1_SAYINLAR: 'Offdock1 Area (Sayınlar)',
                  OFFDOCK2_KOMURLER: 'Offdock2 Area (Kömürler)',

                  // ========== LANDING & LOGIN ==========
                  heroTitle1: 'Control Access,',
                  heroTitle2: 'Secure Your Site',
                  heroSubtitle: 'Transform your site security with digital entry logs, real-time tracking, and smart automated reporting in one professional platform.',
                  startNow: 'Start Now',
                  safeInfra: 'Secure Infrastructure',
                  freeUsage: '100% Free',
                  nonStopTrack: 'Uninterrupted Tracking',
                  highSecurity: 'Data Privacy',
                  highSecurityDesc: 'Your information is stored safely.',
                  realTimeTrack: 'Real-Time Tracking',
                  realTimeTrackDesc: 'Monitor instantly via the panel.',
                  smartReporting: 'Smart Reporting',
                  smartReportingDesc: 'Create custom reports.',
                  googleLogin: 'Continue with Google',
                  appleLogin: 'Continue with Apple',
                  or: 'or',
                  forgotPasswordBtn: 'Forgot Password?',
                  noAccount: "Don't have an account?",
                  register: 'Register',
                  resetPassword: 'Reset Password',
                  resetPasswordDesc: 'Request a password reset link by entering your email address.',
                  send: 'Send',
                  industrialSystem: 'Digital Access & Security Control System',

                  // ✅ Login
                  welcomeBack: 'Welcome Back',
                  enterCredentials: 'Enter your credentials to continue',
                  allRightsReserved: 'All rights reserved.',
                  login: 'Login',
                  loginLoading: 'Logging in...',
                  username: 'Username',
                  password: 'Password',
                  usernamePlaceholder: 'Enter your username',
                  passwordPlaceholder: 'Enter your password',
                  forgotPassword: 'Forgot Password?',
                  forgotPasswordTitle: 'Reset Password',
                  forgotPasswordDesc: 'Enter your email to reset your password',
                  sendResetLink: 'Send Reset Link',
                  sending: 'Sending...',
                  fillAllFields: 'Please fill all fields',
                  missingInfo: 'Missing Info',
                  loginSuccess: 'Login Successful',
                  redirecting: 'Redirecting...',
                  loginDenied: 'Login Denied',
                  invalidCredentials: 'Invalid username or password!',
                  loginFailed: 'Login failed. Please try again.',
                  emailSent: 'Email Sent',
                  resetLinkSent: 'Password reset link has been sent to your email.',
                  operationFailed: 'Action failed.',
                  forgotPasswordHint: 'Forgot your password? Contact support team.',
                  daysUntilExpiry: '{{days}} days left',
                  role: 'Role',
                  admin: 'Admin',
                  security: 'Security',
                  supervisor: 'Supervisor',
                  loginLoading: 'Logging in...',
                  forgotPassword: 'Forgot your password?',
                  forgotPasswordTitle: 'Reset Password',
                  forgotPasswordDesc: 'Please enter your email to receive reset instructions.',
                  sendResetLink: 'Send Reset Link',

                  // ========== PERSONNEL INFO ==========
                  personnelInfo: 'Personnel Information',
                  optional: 'Optional',
                  enterExpiryDates: 'Enter expiry dates (optional)',
                  noDocumentTypes: 'No document types found. Please add document types in Settings first.',
                  goToSettings: 'Go to Settings',
                  areYouSure: 'Are you sure?',
                  documentTypeAdded: 'Document type added',
                  manageDocumentTypes: 'Manage document types',
                  warningDaysHelp: 'How many days before expiry to show warning',
                  days: 'days',

                  // ========== STATUS MESSAGES ==========
                  assignmentExpired: 'Assignment expired - ENTRY DENIED',
                  documentsExpired: 'Documents missing/expired - ENTRY DENIED',
                  documentsWarning: 'Documents expiring soon - WARNING',
                  allDocumentsValid: 'All documents valid - ENTRY ALLOWED',
                  searchPersonnelToCheck: 'Search personnel for entry check',
                  selectPersonnelToViewStatus: 'Select personnel to view status',
                  noDocuments: 'No documents found',

                  // ========== ALERTS ==========
                  expiringDocuments: 'Expiring Documents',
                  noAlerts: 'No alerts',
                  daysLeft: 'days left',
                  alreadyExpired: 'EXPIRED',
                  viewAll: 'View All',
                  alertsIn30Days: 'Documents expiring in 14 days',
                  urgentAlerts: 'URGENT ALERTS',

                  // ========== PAGINATION ==========
                  page: 'Page',
                  previous: 'Previous',
                  next: 'Next',
                  of: 'of',

                  // ========== USER MANAGEMENT ==========
                  userManagement: 'User Management',
                  addUser: 'Add User',
                  editUser: 'Edit User',
                  userCreated: 'User created',
                  userUpdated: 'User updated',
                  userDeleted: 'User deleted',

                  // ========== AUTHORIZATION ==========
                  canEnter: 'Cleared for Entry',
                  cannotEnter: 'Access Restricted',
                  allDocsValid: 'Compliance verified',
                  docProblem: 'Compliance not met',

                  // ========== LOGS ==========
                  accessLogsTitle: 'Entry & Exit Logs',
                  autoRefresh: 'Auto refresh',
                  entryLogsTitle: 'Entry & Exit Logs',
                  last24HoursHint: 'Latest records are listed',
                  openSearch: 'Search Logs',
                  all: 'All',
                  in: 'Entry',
                  out: 'Exit',
                  day: 'Day',
                  refresh: 'Refresh',
                  refreshLatest: 'Refresh latest',
                  noRecordsYet: 'No records yet.',
                  entered: 'ENTERED',
                  exited: 'EXITED',
                  entryTime: 'Entry',
                  exitTime: 'Exit',
                  securityOfficer: 'Security',
                  openPersonnel: 'Open personnel',
                  totalRecords: 'Total {{count}} records',
                  records: 'records',

                  // ========== SEARCH ==========
                  expiringSoon: 'Expiring Soon',
                  alreadyExpiredCount: 'Already Expired',
                  searchByNameCompanyPhone: 'Search by name, company or phone...',
                  showingExpiringFirst: 'Showing expiring first, then expired',
                  noSearchResults: 'No search results found',
                  timeFilter: 'Period',

                  // ========== USERS ==========
                  newUser: 'New User',
                  createdAt: 'Created',
                  noUsersYet: 'No users yet',
                  update: 'Update',
                  passwordHint: 'Leave empty to keep unchanged',

                  // ========== BULK OPERATIONS ==========
                  downloadTemplate: 'Download Template',
                  bulkImportExcel: 'Bulk Import Excel',
                  manualAdd: 'Manual Add',
                  excelFormat: 'Excel Format',
                  requiredColumns: 'Required columns',
                  optionalColumns: 'Optional',
                  dateFormat: 'Date format',
                  importantNote: 'Important',
                  emptyFieldsIgnored: 'Empty fields will be ignored',

                  // ========== LOG FILTERS ==========
                  entryLogsAll: 'All',
                  entryLogsIn: 'Entry',
                  entryLogsOut: 'Exit',
                  entryLogsDay: 'Day',
                  entryLogsRefresh: 'Refresh',
                  entryLogsCalculating: 'Calculating...',
                  entryLogsOnlyOutHint: 'Daily total is shown only on EXIT rows.',
                  entryLogsSearchBtn: 'Log Search',
                  entryLogsNotFound: 'No records found',
                  entryLogsTotal: 'Total {{count}} records',
                  totalRecordsShort: 'Total records',
                  noRecords: 'No records found',
                  date: 'Date',
                  action: 'Action',
                  note: 'Note',
                  officer: 'Officer',
                  duration: 'Total Duration',
                  hoursUnit: 'h',
                  minutesUnit: 'm',
                  secondsUnit: 's',

                  // ✅ Security Check
                  insideTitle: 'Inside',
                  insideSubtitle: 'Personnel currently inside and duration',
                  refresh: 'Refresh',
                  loading: 'Loading...',
                  noOneInside: 'No one inside.',
                  totalDuration: 'Total Duration',
                  security: 'SECURITY',
                  gate: 'Gate',
                  allowEntry: 'Allow Entry',
                  allowExit: 'Allow Exit',
                  personnelInside: 'Personnel inside',
                  personnelNotInside: 'Personnel not inside',
                  noEntryPermission: 'No entry permission',
                  assignmentDuration: 'ASSIGNMENT DURATION',
                  selectPersonnelPlaceholder: 'Select personnel to view status',
                  searchFailed: 'Search failed',
                  failedToLoadDetails: 'Failed to load details',
                  personNotFound: 'Personnel not found',
                  entrySaved: 'Entry saved',
                  exitSaved: 'Exit saved',
                  operationFailed: 'Operation failed',

                  personSearch: 'Person Search',
                  name: 'Name',
                  surname: 'Surname',
                  searchAction: 'SEARCH',
                  searchFormWarning: 'To search, please fill in at least one of the fields above (<1>Name, Surname or ID Number</1>).',
                  daysShort: 'd',
                  hoursUnit: 'h',
                  minutesUnit: 'm',
                  secondsUnit: 's',
                  entryTime: 'Entry Time',
                  insideTime: 'Time Inside',

                  // ========== LOG SEARCH ==========
                  entryLogsSearchTitle: 'Log Search',
                  entryLogsSearchSubtitle: 'Search in detail',
                  entryLogsSearchPlaceholder: 'Search by name / company / note / security...',
                  entryLogsSearchBtnShort: 'Search',
                  entryLogsSearchSearching: 'Searching...',
                  entryLogsSearchNoResult: 'No results found',
                  entryLogsSearchDayFilter: 'Day filter',
                  entryLogsSearchHintOn: 'Day filter ON: only selected day is scanned.',
                  entryLogsSearchHintOff: 'Day filter OFF: scans past logs page by page.',
                  entryLogsSearchScanned: 'Scanned pages: {{scanned}} / {{total}} — Found: {{found}}',
                  entryLogsSearchTotalDuration: 'Total Duration',
                  entryLogsSearchSecurity: 'Security',
                  entryLogsSearchNoteLabel: 'Note',
                  entryLogsSearchDateLabel: 'Date',
                  entryLogsSearchEntry: 'Entry',
                  entryLogsSearchExit: 'Exit',

                  // ========== NEW ADDITIONS (EntryLogsSearch) ==========
                  searchRecords: 'Search Records',
                  searchDetailed: 'Perform detailed search',
                  searchAllFields: 'Search name / company / note / officer / site...',
                  allRecords: 'All',
                  dayFilterEnabled: 'Day filter ON: only selected day scanned.',
                  dayFilterDisabled: 'Day filter OFF: all past records scanned.',
                  scannedInfo: 'Scanned: {{scanned}} / {{total}} — Found: {{found}}',
                  totalDurationLabel: 'Total Duration:',
                  site: 'Site',

                  // ========== SHORT LOG SEARCH ==========
                  logsSearchTitle: 'Log Search',
                  searchHint: 'Search by name / company / note / officer...',
                  dayFilter: 'Day filter',
                  searching: 'Searching...',
                  scannedPages: 'Scanned pages',
                  found: 'Found',
                  entry: 'IN',
                  exit: 'OUT',

                  // ========== DASHBOARD EXTRAS ==========
                  entryExitLogsTitle: 'Entry & Exit Logs',
                  showingLastHours: 'Showing last {{hours}} hours',
                  entryLabel: 'Entry:',
                  exitLabel: 'Exit:',
                  durationLabel: 'Duration:',
                  insideLabel: 'Inside:',
                  guardLabel: 'Guard:',
                  enteredFacility: '{{name}} entered the facility',
                  exitedFacility: '{{name}} exited the facility',
                  openLogsArchive: 'Open Logs Archive',
                  refreshBtn: 'Refresh',
                  loadingLogs: 'Loading logs...',
                  noActivityLastHours: 'No activity in last {{hours}} hours.',
                  noRecentActivity: 'No activity recorded in last 24 hours',
                  logsLoadFailed: 'Failed to load logs',
                  durationHMS: '{{h}} h {{m}} m {{s}} s',
                  durationMS: '{{m}} m {{s}} s',
                  urgentExpiresInDays: 'Expiring within {{days}} days',
                  mostUrgent: 'Most urgent',
                  noUrgentAlerts: 'No urgent alerts',

                  // ========== LOG LIST ==========
                  entryExitRecords: 'Entry & Exit Records',
                  showingLast24Hours: 'Showing last 24 hours',
                  searchRecord: 'Search Record',
                  insideTime: 'Inside',
                  lessThanOneMinute: '<1 min',
                  minutesShort: '{{m}} m',
                  hoursMinutesShort: '{{h}} h {{m}} m',
                  searchDetailedHint: 'Perform detailed search',
                  searchButton: 'Search',
                  dayFilter: 'Day filter',
                  calculating: 'calculating...',
                  ready: 'ready',
                  searching: 'Searching...',
                  noteLabel: 'Note',
                  guardLabel: 'Security:',
                  searchDayFilterOn: 'Day filter ON: only selected day is scanned.',
                  searchDayFilterOff: 'Day filter OFF: scans all past records.',
                  scannedPagesInfo: 'Scanned pages: {{scanned}} / {{total}} — Found: {{found}}',
                  totalDuration: 'Total Duration',
                  noResultsFound: 'No results found',

                  // ✅ Personnel Page
                  personnelLoadFailed: 'Failed to load personnel',
                  personnelDeleted: 'Personnel deleted',
                  downloadPersonnelBackup: 'Personnel Excel Backup',
                  preparingExcel: 'Preparing Excel...',
                  personnelBackupDownloaded: 'Personnel Excel backup downloaded',
                  personnelBackupFailed: 'Personnel Excel backup could not be created',
                  personnelDeleteFailed: 'Failed to delete personnel',
                  bulkDeleteSuccess: '✅ {{count}} records deleted',
                  bulkDeleteFailed: 'Bulk delete failed',
                  importSuccess: '✅ {{imported}} personnel added, {{skipped}} skipped',
                  importWarning: '⚠️ {{count}} errors occurred. Check console.',
                  importFailed: 'Excel import failed',
                  templateDownloaded: 'Template downloaded',
                  templateDownloadFailed: 'Template download failed',
                  deletePageItems: 'Delete Page Items ({{count}})',
                  deleteSelected: 'Delete Selected ({{count}})',
                  uploading: 'Uploading...',
                  clearSelection: 'Clear Selection',
                  clearFilters: 'Clear',
                  allPersonnel: 'All',
                  canEnterFilter: 'Can Enter',
                  cannotEnterFilter: 'Cannot Enter',
                  searchNameTcCompany: 'Name, ID, Company...',
                  allCompanies: 'All Companies',
                  onlySelected: 'Only selected',
                  totalLabel: 'Total',
                  visibleLabel: 'Visible',
                  totalPersonnelCount: 'Total {{count}} personnel',
                  pageOf: 'Page {{current}} of {{total}}',
                  deleteSelectedTitle: 'Delete Selected',
                  deletePageItemsTitle: 'Delete Page Records',
                  deleteConfirmMessage: 'This action cannot be undone. To continue, type',
                  deleteKeyword: 'DELETE',
                  typeToConfirm: 'to confirm.',
                  cancelAction: 'Cancel',
                  deleteButton: 'Delete',

                  // ========== SETTINGS ==========
                  settingsTitle: 'Settings',
                  documentTypesTitle: 'Document Types',
                  documentTypesSubtitle: 'Manage document types',
                  addDocumentTypeTitle: 'Add Document Type',
                  nameTrLabel: 'Turkish Name',
                  nameEnLabel: 'English Name',
                  warningDaysLabel: 'Warning Days',
                  warningDaysHint: 'How many days before expiry to show warning',
                  mandatoryDocument: 'Mandatory Document',
                  noDocumentTypesYet: 'No document types yet',
                  documentTypeDeleteConfirm: 'Delete this document type?',
                  documentTypeDeleted: 'Document type deleted',
                  documentTypeDeleteFailed: 'Failed to delete document type',
                  documentTypeCreateFailed: 'Failed to add document type',

                  // ========== SMS TEST ==========
                  smsTestTitle: 'SMS Test',
                  phoneLabel: 'Phone',
                  messageLabel: 'Message',
                  countryCodeHint: 'Include country code (e.g. +90)',
                  sending: 'Sending...',
                  sendTestSms: 'Send Test SMS',
                  smsSent: 'SMS sent successfully',
                  smsSendFailed: 'Failed to send SMS',
                  smsNoteTitle: 'Note',
                  smsBackendNote: 'For SMS service, Twilio credentials must be configured in backend .env. Contact admin: TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN, TWILIO_PHONE_NUMBER',

                  // ========== PERSONNEL DETAIL ==========
                  personnelNotFound: 'Personnel not found',
                  failedToLoadData: 'Failed to load data',
                  personnelUpdated: 'Personnel updated',
                  updateFailed: 'Update failed',
                  documentAdded: 'Document added',
                  documentAddFailed: 'Failed to add document',
                  documentDeleted: 'Document deleted',
                  documentDeleteFailed: 'Failed to delete document',
                  personnelAddSuccess: 'Personnel added successfully',
                  personnelAddFailed: 'Failed to add personnel',
                  docTypesLoadFailed: 'Failed to load document types',
                  confirmDelete: 'Are you sure?',
                  newDocumentAdd: 'Add New Document',
                  select: 'Select',
                  expiresOn: 'Expiry',

                  // ========== PERSONNEL ACTION GRID ==========
                  singleEntryDesc: 'Single personnel entry',
                  selectAndUploadFile: 'Select & Upload File',
                  deleteSelectedCount: 'Delete Selected ({{count}})',
                  deletePageAll: 'Delete All on Page ({{count}})',
                  bulkActionHint: 'Select items for bulk actions',

                  // ========== REPORT ==========
                  bulkActions: 'Bulk Actions',
                  // Report
                  downloadReport: 'Download Report',
                  downloadMonthlyReport: 'Download Monthly Report',
                  year: 'Year',
                  month: 'Month',
                  downloadExcel: 'Download Excel',
                  downloadFailed: 'Download failed',

                  // ========== ADDED FOR SECURITYCHECK ==========
                  inside: 'Inside',
                  liveInsideList: 'Real-time personnel inside and durations',
                  siteSelection: 'Site Selection',
                  simulation: 'Simulation',
                  giveEntry: 'Give Entry',
                  giveExit: 'Give Exit',
                  personnelInside: 'Personnel inside',
                  personnelNotInside: 'Personnel not inside',
                  noEntryPermission: 'No entry permission',
                  docsNotSuitable: 'Docs/Assignment not suitable',
                  entrySaved: 'Entry saved',
                  exitSaved: 'Exit saved',
                  operationFailed: 'Operation failed',
                  noOneInside: 'No one inside',
                  cannotExit: 'Cannot exit',
                  failedToLoadDetails: 'Failed to load details',

                  // ========== FOR ENTRYCHECK ==========
                  manualEntry: 'Manual Entry',
                  manualEntryControls: 'Manual Entry Controls',

                  // ========== COMING SOON ==========
                  comingSoonTitle: 'Coming Soon',
                  comingSoonDesc: 'This feature is not yet available. It will be enabled soon.',
            },
      },
};

i18n.use(initReactI18next).init({
      resources,
      lng: getInitialLang(),
      fallbackLng: 'tr',
      interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
      if (lng === 'tr' || lng === 'en') {
            localStorage.setItem(STORAGE_LANG_KEY, lng);
      }
});

export default i18n;
